export enum HeaderAnimationPhases {
    preOpenChange = "preOpenChange",
    PreOpen = "preOpen",
    Open = "open",
    PreClosedChange = "preClosedChange",
    PreClosed = "preClosed",
    Closed = "closed",
}